export const CronFormat = {
  CronFormatter_Frequency_MonthlyTemplate: _TL_('Runs {{frequency}} on day {{dayOfMonth}} at {{hour}}'),
  CronFormatter_Frequency_WeeklyTemplate: _TL_('Runs {{frequency}} on {{dayOfWeek}} at {{hour}}'),
  CronFormatter_Frequency_DailyTemplate: _TL_('Runs {{frequency}} at {{hour}}'),
  CronFormatter_FrequencyGrain_Runs_Daily: _TL_('daily'),
  CronFormatter_FrequencyGrain_Runs_Monthly: _TL_('monthly'),
  CronFormatter_FrequencyGrain_Runs_Weekly: _TL_('weekly'),
  CronFormatter_FrequencyGrain_DropdownMenu_None: _TL_('None'),
  CronFormatter_FrequencyGrain_DropdownMenu_Daily: _TL_('Daily'),
  CronFormatter_FrequencyGrain_DropdownMenu_Monthly: _TL_('Monthly'),
  CronFormatter_FrequencyGrain_DropdownMenu_Weekly: _TL_('Weekly'),
};
